import CustomInput from "../../components/CustomInput/Input";
import {
    companyNameRules,
    nameRules,
    emailRules,
    websiteRules,
    phoneNumberRules,
} from "../../helpers/helpers";
import CountryCode from "../../components/CountryCodeSelect/CountryCode";
import { Alert } from "antd";
import { DESC_TXT } from "../../constants/constants";

const BasicInfoForm = ({
    isVerified,
    email,
    phoneNumber,
    handleVerifyBtnClick,
    dealTypeId,
    typeDisabled
}) => {
    return (
        <>
            <Alert
                message={DESC_TXT.POC_DIRECTOR_NOTE}
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />
            <CustomInput
                label="Company Name"
                name="busName"
                type="text"
                isRequired={true}
                disabled={typeDisabled}
                placeholder="Enter your Company Name"
                rules={companyNameRules("Company")}
            />
            <CustomInput
                label="Company Contact Name"
                name="contactName"
                type="text"
                isRequired={true}
                disabled={typeDisabled}
                placeholder="Enter Company Contact Name"
                rules={nameRules("Company Contact")}
            />
            <CustomInput
                label="Contact Email"
                name="contactEmail"
                type="email"
                isRequired={true}
                disabled={typeDisabled}
                placeholder="Enter your Contact email address"
                rules={emailRules("Contact")}
                verifyBtn={true}
                isVerified={isVerified.email}
                disableVerify={
                    isVerified.email ||
                    !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email || "")
                }
                handleVerify={() => handleVerifyBtnClick("email")}
            />

            <CustomInput
                label="Point of Contact Phone Number (Should be linked with Aadhaar)"
                name="pocPhoneNumber"
                addonBefore={<CountryCode />}
                placeholder="Phone Number"
                rules={phoneNumberRules("Point of Contact")}
                verifyBtn={true}
                isRequired={true}
                disabled={typeDisabled}
                isVerified={isVerified.mobile}
                disableVerify={
                    isVerified.mobile || !/^[6-9]\d{9}$/.test(phoneNumber || "")
                }
                handleVerify={() => handleVerifyBtnClick("mobile")}
            />
            <CustomInput
                label="Company Website"
                name="website"
                type="text"
                isRequired={false}
                disabled={typeDisabled}
                placeholder="Enter Company Website"
                rules={websiteRules}
                removeHttps={true}

            />
        </>
    );
};

export default BasicInfoForm;
